import { https } from './https';
import { api_url } from './../Configuration/config';

export async function getAllUsers(obj=''){
    return await https.get(`${api_url}admin/users?${obj}`);
}
